/** Analytics abstraction — no-op locally; forwards to PostHog when window.posthog exists. */

const EVENTS = new Set([
  "page_viewed", "signup_started", "signup_completed", "project_created",
  "asset_uploaded", "voice_memo_added", "script_generated", "storyboard_generated",
  "preview_opened", "export_clicked", "launch_kit_generated", "pricing_viewed",
  "upgrade_clicked", "checkout_started", "render_started", "render_completed", "render_failed",
]);

export function track(event, properties = {}) {
  if (!EVENTS.has(event)) {
    console.debug("[analytics] unknown event:", event);
  }
  if (typeof window !== "undefined" && window.posthog?.capture) {
    window.posthog.capture(event, properties);
    return;
  }
  if (process.env.NODE_ENV === "development") {
    console.debug("[analytics]", event, properties);
  }
}

export function trackPage(path) {
  track("page_viewed", { path });
}
